import React from 'react';
import PropTypes from 'prop-types';

export const AddressListing = ({ fullName, firstName, lastName, street1, street2, city, state, postalCode }) => (
    <React.Fragment>
        <div>{fullName || `${firstName} ${lastName}`}</div>
        <div>{street1}</div>
        {street2 && <div>{street2}</div>}
        <div>{`${city}, ${state} ${postalCode}`}</div>
    </React.Fragment>
);

AddressListing.defaultProps = {
    fullName: undefined,
    firstName: undefined,
    lastName: undefined,
    street2: undefined
};

AddressListing.propTypes = {
    fullName: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    street1: PropTypes.string.isRequired,
    street2: PropTypes.string,
    city: PropTypes.string.isRequired,
    state: PropTypes.string.isRequired,
    postalCode: PropTypes.string.isRequired
};
